/* ==========================================================================
 * nc-geburtstag-gift.js  ·  THE NESTING CLUB
 * Geburtstags-Countdown als GRATIS-Zugabe zum Allwetter-Set (Aktion OHNE festes
 * Enddatum – Tanja-Entscheid 07.09.2026, läuft bis auf Widerruf).
 * Nachfolger von nc-schulstart-gift.js (Struktur 1:1 übernommen, siehe
 * docs/orchestration/geburtstags-aktion-umbau.md), Konsolidierungs-/Kundenschutz-
 * Logik unverändert – nur die Geschenk-Variante + Wegfall des Datums-Guards.
 * --------------------------------------------------------------------------
 * Verhalten:
 *  1. Liegt das Allwetter-Set (Variante SET_VARIANT) im Warenkorb, wird der
 *     Geburtstags-Countdown (Variante GIFT_VARIANT) automatisch in gleicher Menge
 *     als Geschenk ergänzt (Line-Item-Property _geschenk = versteckt im Checkout).
 *  2. Pro Set genau 1 Geschenk – nie doppelt (Menge wird an die Set-Menge gekoppelt).
 *  3. Cleanup: kein Set (mehr) im Warenkorb → Geschenk wird automatisch entfernt.
 *  4. Geschenk-Zeile wird auf der Warenkorb-Seite als „🎂 … GRATIS Geschenk"
 *     gekennzeichnet (Badge). Die nativen Shopify +/−- und Entfernen-Regler bleiben
 *     sichtbar/bedienbar (Tanja 11.08.2026, für Schulstart-Vorgänger entschieden,
 *     hier 1:1 übernommen) – KEIN hartes Sperren. Dreht der Kunde direkt am
 *     Geschenk, synct reconcile() die Menge sanft auf die Set-Menge zurück.
 *  5. KEIN Datums-Guard (Tanja-Entscheid 07.09.2026: Aktion ohne festes Enddatum) –
 *     das Geschenk wird hinzugefügt/gehalten, solange ein Allwetter-Set im Cart liegt.
 *  6. Kombinierbarkeit (analog Schulstart-Vorgänger, 11.08.2026): Der Gratis-Rabatt
 *     IST mit DANKE10 (Order-Rabatt) kombinierbar (BXGY combinesWith.orderDiscounts:
 *     true). Das Geschenk wird deshalb IMMER hinzugefügt/gehalten, sobald ein
 *     Allwetter-Set im Cart liegt – UNABHÄNGIG von DANKE10; es ist ohnehin immer €0.
 *     KEINE Order-Rabatt-Blocklogik, KEIN „nicht kombinierbar"-Hinweis.
 *
 * Kein Fake-Countdown. Reiner Cart-Reconcile über /cart/*.js + /cart.js.
 * Der €0-Preis der Geschenk-Zeile kommt aus dem automatischen BXGY-Rabatt
 * (deploy-geburtstag-gift-discount.js) – dieses JS steuert nur Menge & Kennzeichnung.
 *
 * ⚠️ SHOP-EINSTELLUNG (Pflicht solange die Aktion läuft): `show_dynamic_checkout`
 *    (Express-Checkout-Buttons: Shop Pay / PayPal / GPay) für das-allwetter-set AUS
 *    lassen. Sonst springt der Kunde per Express-Button direkt in den Checkout,
 *    bevor dieses JS die Geschenk-Zeile hinzufügen konnte – der BXGY-Rabatt kann
 *    eine FEHLENDE Zeile nicht nachliefern (BXGY rabattiert nur, es legt Y NICHT
 *    selbst in den Cart).
 *
 * Zeilen-Erkennung des Geschenks: NUR über die Line-Item-Property `_geschenk`
 * (aus /cart.js), NICHT über den Produkt-Link. So bleibt ein zusätzlich ECHT
 * BEZAHLTER Geburtstags-Countdown (eigene Cart-Zeile ohne `_geschenk`) normal
 * bedienbar und wird nicht fälschlich als gratis markiert/gesperrt.
 * ========================================================================== */
(function () {
  'use strict';
  if (window.__ncGeburtstagGiftInit) return;
  window.__ncGeburtstagGiftInit = true;

  // ---- Konfiguration --------------------------------------------------------
  var SET_VARIANT = 56025230934356;      // Das Allwetter-Set
  var GIFT_VARIANT = 56025229787476;     // Geburtstags-Countdown (Geschenk)
  var GIFT_PROP_KEY = '_geschenk';
  var GIFT_PROP_VAL = 'Geburtstags-Countdown gratis zum Allwetter-Set';
  var GIFT_MAX = 10;                      // Sicherheits-Cap (Missbrauch/Fehler)
  // Kein Aktionsende (Tanja-Entscheid 07.09.2026) – Aktion läuft bis auf Widerruf.

  function isActive() { return true; }

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function url(p) { return (ROOT.replace(/\/$/, '')) + p; }

  var ncInternal = false;   // true, solange dieses Script selbst fetch()t → Wrap ignoriert es
  var ncBusy = false;       // Single-Flight-Guard für reconcile()
  var ncPending = false;    // reconcile nochmal nötig?
  var ncGiftKeys = [];      // Line-Keys der Geschenk-Zeilen (mit _geschenk-Property) aus /cart.js
                            //  → Keys sind stabil über Dawns Mengen-Re-Renders (Key = Variante+Property-Hash).

  // ---- kleine Helfer --------------------------------------------------------
  function jfetch(path, opts) {
    ncInternal = true;
    var base = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    var o = Object.assign(base, opts || {});
    return fetch(url(path), o).then(function (r) {
      return r.text().then(function (t) {
        var j = null; try { j = JSON.parse(t); } catch (e) {}
        return { ok: r.ok, json: j };
      });
    }).finally(function () { ncInternal = false; });
  }

  function innerFromHTML(html, selector) {
    var d = document.createElement('div');
    d.innerHTML = html;
    var el = d.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  // Section-IDs der aktuell sichtbaren Cart-Bauteile (für Section Rendering API)
  function currentSections() {
    var out = [];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) out.push(items.dataset.id);
    if (footer && footer.dataset.id) out.push(footer.dataset.id);
    out.push('cart-icon-bubble');
    return out;
  }

  function applyRenderedSections(sections) {
    if (!sections) return;
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id && sections[items.dataset.id]) {
      var inner = innerFromHTML(sections[items.dataset.id], '.js-contents');
      var t = items.querySelector('.js-contents');
      if (inner != null && t) t.innerHTML = inner;
    }
    if (footer && footer.dataset.id && sections[footer.dataset.id]) {
      var finner = innerFromHTML(sections[footer.dataset.id], '.js-contents');
      var ft = footer.querySelector('.js-contents');
      if (finner != null && ft) ft.innerHTML = finner;
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var binner = innerFromHTML(sections['cart-icon-bubble'], '#cart-icon-bubble')
        || innerFromHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (binner != null) bubble.innerHTML = binner;
    }
    document.dispatchEvent(new CustomEvent('nc:cart-updated'));
  }

  // ---- Cart-Zustand analysieren --------------------------------------------
  // Geschenk = NUR Zeilen mit der _geschenk-Property (nicht jede Geburtstags-Zeile!).
  // WICHTIG: Shopify SPLITTET eine Geschenk-Zeile, wenn der Gratis-Rabatt sie nur teilweise
  // deckt (z. B. Set 2→1 bei Geschenk-Menge 2 → 1 gedeckte + 1 berechnete Zeile, je eigener
  // Key). Deshalb IMMER über ALLE _geschenk-Zeilen summieren (giftTotal), nie mit einer Zeile.
  function analyze(cart) {
    var setQty = 0, giftLines = [], giftKeys = [], giftTotal = 0, chargedTotal = 0;
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === SET_VARIANT || it.id === SET_VARIANT) setQty += it.quantity;
      var props = it.properties || {};
      var isGift = (it.variant_id === GIFT_VARIANT || it.id === GIFT_VARIANT) && props && props[GIFT_PROP_KEY];
      if (isGift) {
        giftLines.push({ key: it.key, quantity: it.quantity });
        giftKeys.push(it.key);
        giftTotal += it.quantity;
        chargedTotal += (it.final_line_price || 0);
      }
    });
    // chargedTotal ist nur ein Sicherheitsnetz-Indikator – bei kombinierbarem Rabatt immer 0.
    return {
      setQty: setQty, giftLines: giftLines, giftKeys: giftKeys,
      giftTotal: giftTotal, chargedTotal: chargedTotal
    };
  }

  // ---- Kernlogik: Geschenk-Menge an Set-Menge angleichen -------------------
  function reconcile() {
    if (ncBusy) { ncPending = true; return; }
    ncBusy = true;
    var mutated = false;

    jfetch('/cart.js', { method: 'GET' })
      .then(function (res) {
        if (!res.ok || !res.json) return null;
        var st = analyze(res.json);
        ncGiftKeys = st.giftKeys;   // Cache für die (property-genaue) Zeilen-Kennzeichnung

        // Ziel-GESAMTmenge des Geschenks = Set-Menge (in BEIDE Richtungen), gedeckelt.
        // 0, wenn kein Set im Cart. Kein Order-Rabatt-Handling mehr: Geschenk immer
        // dabei (kombinierbar & €0). Kein Datums-Guard (Aktion ohne Enddatum).
        var target = (isActive() && st.setQty > 0) ? Math.min(st.setQty, GIFT_MAX) : 0;

        // Mutation nötig, wenn: Menge weicht ab, ODER das Geschenk liegt (durch Rabatt-Split)
        // auf mehreren Zeilen → konsolidieren. Beides deckt zugleich das Sicherheitsnetz ab:
        // eine je berechnete Geschenk-Einheit kann realistisch nur aus Über-Menge/Split kommen,
        // und genau diese beiden Fälle lösen hier eine Konsolidierung auf die Set-Menge aus.
        var needMutation = (target !== st.giftTotal) || (target > 0 && st.giftLines.length > 1);
        if (!needMutation) return null; // nichts zu tun

        mutated = true;
        var sections = currentSections().join(',');

        if (st.giftLines.length === 0) {
          // Geschenk NEU hinzufügen (nur erreichbar, wenn target > 0)
          var props = {};
          props[GIFT_PROP_KEY] = GIFT_PROP_VAL;
          return jfetch('/cart/add.js', {
            method: 'POST',
            body: JSON.stringify({
              items: [{ id: GIFT_VARIANT, quantity: target, properties: props }],
              sections: sections,
              sections_url: window.location.pathname
            })
          });
        }
        // Bestehende Geschenk-Zeile(n) ATOMAR auf die Ziel-Gesamtmenge bringen:
        // erste Zeile = target, alle weiteren = 0. /cart/update.js mit line-key-Objekt ist
        // atomar und immun gegen Key-Shift; identische Variante+Property mergen zu EINER Zeile
        // (konsolidiert Rabatt-Split-Zeilen). Empirisch verifiziert (Schulstart-Vorgänger).
        var updates = {};
        st.giftLines.forEach(function (gl, i) { updates[gl.key] = (i === 0) ? target : 0; });
        return jfetch('/cart/update.js', {
          method: 'POST',
          body: JSON.stringify({
            updates: updates,
            sections: sections,
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (res) {
        if (res && res.ok && res.json && res.json.sections) applyRenderedSections(res.json.sections);
        // Nach einer Mutation die Geschenk-Keys frisch ziehen → neu hinzugefügte
        // Geschenk-Zeile wird sofort (property-genau) gekennzeichnet.
        if (mutated) {
          return jfetch('/cart.js', { method: 'GET' }).then(function (r2) {
            if (r2.ok && r2.json) ncGiftKeys = analyze(r2.json).giftKeys;
          });
        }
      })
      .catch(function () {
        // Auf der Cart-Seite lieber sauber neu laden, wenn eine Mutation nötig war
        if (mutated && document.getElementById('main-cart-items')) window.location.reload();
      })
      .finally(function () {
        // DOM-Update (Badge) noch UNTER ncBusy=true → der MutationObserver ignoriert unsere
        // eigenen Schreibvorgänge (kein Selbst-Loop). Erst danach freigeben.
        applyMarks();
        ncBusy = false;
        if (ncPending) { ncPending = false; setTimeout(reconcile, 60); }
      });
  }

  // Debounce, damit mehrere schnelle Cart-Events zu genau einem reconcile werden
  var schedTimer = null;
  function scheduleReconcile() {
    if (schedTimer) clearTimeout(schedTimer);
    schedTimer = setTimeout(function () { schedTimer = null; reconcile(); }, 220);
  }

  // ---- fetch-Wrap: reagiere nach jeder Cart-Mutation (auch von Dawn) --------
  var CART_MUT = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  window.fetch = function () {
    var p = origFetch.apply(this, arguments);
    try {
      var a0 = arguments[0];
      var u = (typeof a0 === 'string') ? a0 : (a0 && a0.url) || '';
      if (!ncInternal && CART_MUT.test(u)) {
        p.then(function () { scheduleReconcile(); }).catch(function () {});
      }
    } catch (e) {}
    return p; // Original-Promise unverändert an Dawn zurück
  };

  // ---- Kennzeichnung der Geschenk-Zeile auf der Cart-Seite -----------------
  function ensureStyle() {
    if (document.getElementById('nc-gift-style')) return;
    var s = document.createElement('style');
    s.id = 'nc-gift-style';
    s.textContent =
      // NUR Kennzeichnung – KEIN Sperren mehr: die nativen Shopify +/−- und Entfernen-Regler
      // der Geschenk-Zeile bleiben sichtbar/bedienbar (analog Schulstart-Vorgänger, 11.08.2026).
      // reconcile() synct die Menge sanft auf die Set-Menge zurück, wenn der Kunde direkt am
      // Geschenk dreht. Kampagnen-Farbe Bernstein (Konsistenz zu PDP/LP); #83500f = AA-fest
      // auf hellem Grund.
      '.nc-gift-badge{display:inline-flex;align-items:center;gap:.4rem;margin:.3rem 0 .1rem;' +
      'padding:.25rem .6rem;border-radius:999px;background:#fdf9f0;color:#83500f;' +
      'border:1px solid rgba(212,146,58,.4);' +
      'font-size:1.15rem;font-weight:600;line-height:1.3;letter-spacing:.01em;}' +
      '.nc-gift-note{display:block;margin:.25rem 0 0;font-size:1.1rem;color:rgba(74,74,72,.85);}';
    document.head.appendChild(s);
  }

  function markRow(row) {
    if (!row || row.classList.contains('nc-gift-line')) return;
    row.classList.add('nc-gift-line');
    var details = row.querySelector('.cart-item__details');
    if (details && !details.querySelector('.nc-gift-badge')) {
      var badge = document.createElement('span');
      badge.className = 'nc-gift-badge';
      badge.textContent = '🎂 GRATIS Geschenk';
      var name = details.querySelector('.cart-item__name');
      if (name && name.parentNode) name.parentNode.insertBefore(badge, name.nextSibling);
      else details.insertBefore(badge, details.firstChild);
      var note = document.createElement('span');
      note.className = 'nc-gift-note';
      note.textContent = 'Gratis zum Allwetter-Set – Menge folgt automatisch dem Set.';
      badge.insertAdjacentElement('afterend', note);
    }
    // Kein Sperren der nativen Mengen-/Entfernen-Regler mehr (analog Schulstart-Vorgänger).
  }

  // Line-Key aus der Entfernen-Link-URL der Zeile lesen (…/cart/change?id=<key>&quantity=0)
  function rowKey(row) {
    var a = row.querySelector('a[href*="/cart/change?id="]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/[?&]id=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // NUR Zeilen kennzeichnen, deren Line-Key eine _geschenk-Property trägt (aus /cart.js).
  // Ein zusätzlich bezahlter Geburtstags-Countdown (eigene Zeile, eigener Key, ohne
  // _geschenk) bleibt unmarkiert und normal bedienbar.
  function applyMarks() {
    var container = document.getElementById('main-cart-items');
    if (!container) return; // nicht auf der Cart-Seite
    if (!ncGiftKeys.length) return; // kein Geschenk im Cart → nichts zu markieren
    ensureStyle();
    var rows = container.querySelectorAll('.cart-item');
    rows.forEach(function (row) {
      var k = rowKey(row);
      if (k && ncGiftKeys.indexOf(k) !== -1) markRow(row);
    });
  }

  // Nach Dawns eigenem Re-Render (native Mengenänderung / Entfernen einer Zeile) neu
  // kennzeichnen UND re-syncen. Der MutationObserver ist der Backstop, falls ein natives
  // /cart/change nicht über den fetch-Wrap läuft: er triggert reconcile() bei JEDER von
  // Dawn ausgelösten Cart-DOM-Änderung – so folgt die Geschenk-Menge der Set-Menge auch
  // beim nativen „−". Eigene Renders (ncBusy) werden ignoriert → kein Selbst-Loop.
  function observeCart() {
    var container = document.getElementById('main-cart-items');
    if (!container) return;
    var mo = new MutationObserver(function () {
      if (ncBusy) return; // eigener Section-Swap/Badge → nicht selbst neu triggern
      if (observeCart._t) clearTimeout(observeCart._t);
      observeCart._t = setTimeout(function () { applyMarks(); scheduleReconcile(); }, 60);
    });
    mo.observe(container, { childList: true, subtree: true });
  }

  // ---- Start ---------------------------------------------------------------
  function boot() {
    applyMarks();
    observeCart();
    reconcile(); // beim Laden: Set→Geschenk angleichen bzw. Cleanup
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
